import { monitoring } from "../functional/monitoring";
import { ErrorCodes } from "./types/enums";
export const createUrl = (endpoint, queryParams) => {
    const url = new URL(endpoint);
    if (queryParams) {
        Object.entries(queryParams).forEach(([key, value]) => {
            url.searchParams.append(key, value);
        });
    }
    return url;
};
export const fetchData = async (params) => {
    const { endpoint, method = "GET", body, queryParams } = params;
    try {
        const response = await fetch(createUrl(endpoint, queryParams).toString(), {
            method: method,
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: body ? JSON.stringify(body) : undefined,
        });
        const responseData = await response.json();
        if (!response.ok) {
            if (response.status === 429) {
                throw new Error(ErrorCodes.RATE_LIMIT);
            }
            if (responseData) {
                throw new Error(responseData.errorCode);
            }
            throw new Error("ResponseData undefined - unknown error in fetchData");
        }
        if (!responseData) {
            return response;
        }
        const cameledResponseData = snakeToCamelCase(JSON.stringify(responseData));
        return JSON.parse(cameledResponseData);
    }
    catch (error) {
        monitoring.logError(error, `Error fetching data`);
        throw error;
    }
};
export const snakeToCamelCase = (str) => str
    .trim()
    .replace(/("\w+":)/g, (keys) => keys.replace(/(.(_|-|\s)+.)/g, (subStr) => subStr[0] + subStr[subStr.length - 1].toUpperCase()));
//# sourceMappingURL=api.js.map